import React, { useContext } from 'react'
import { format, isEqual, isSameMonth, startOfDay, isBefore, isAfter, isValid, isWithinInterval } from 'date-fns'
import { DatePickerContext } from '../DatePickerProvider'
import { DayButton, DayContainer } from './Day.styles'
import { useFormContext } from 'react-hook-form'
import { dateToPFormat, pFormatToDate } from '../helpers'

export default function Day({ day, isEndOfWeek, isStartOfWeek }) {
  const {
    dateNameSelected,
    locale,
    onChange,
    blockFutureDates,
    blockPastDates,
    referenceDay,
    setDateNameSelected,
    singleDateMode,
    editMode
  } = useContext(DatePickerContext)
  const { setValue, getValues, clearErrors } = useFormContext()

  const startDateValue = getValues('startDate')
  const endDateValue = getValues('endDate')
  
  const startDate = startDateValue ? pFormatToDate(startDateValue, locale) : null
  const endDate = endDateValue ? pFormatToDate(endDateValue, locale) : null

  const isSelected = (startDate && isValid(startDate) && isEqual(day, startDate)) || 
                    (endDate && isValid(endDate) && isEqual(day, endDate))
  
  const isInSelection = !singleDateMode && 
                       startDate && 
                       endDate && 
                       isValid(startDate) && 
                       isValid(endDate) && 
                       startDate <= endDate &&
                       isWithinInterval(day, { start: startDate, end: endDate })
  
  const isOutOfMonth = !isSameMonth(day, referenceDay)
  
  const normalizedToday = startOfDay(new Date())
  const normalizedDay = startOfDay(day)
  const normalizedStartDate = startDate ? startOfDay(startDate) : null
  
  let isDisabled = false
  
  if (editMode && normalizedStartDate) {
    isDisabled = isBefore(normalizedDay, normalizedStartDate) || isEqual(normalizedDay, normalizedStartDate)
  } else {
    isDisabled = (blockFutureDates && isAfter(normalizedDay, normalizedToday)) || 
                 (blockPastDates && isBefore(normalizedDay, normalizedToday))
  }

  const handleClick = () => {
    if (isDisabled) {
      return
    }

    clearErrors()

    if (singleDateMode) {
      const newDate = dateToPFormat(day, locale)
      setValue('startDate', newDate)
      setValue('endDate', '')
      onChange(day)
      return
    }

    if (editMode) {
      setValue('endDate', dateToPFormat(day, locale))
      setValue('presetSelection', null)
      onChange(startDate, day)
      return
    }
    
    if (dateNameSelected === 'startDate') {
      setValue('startDate', dateToPFormat(day, locale))
      setValue('endDate', '')
      setValue('presetSelection', null)
      setDateNameSelected('endDate')
      onChange(day, null)
    } else {
      if (startDate && isValid(startDate) && day < startDate) {
        setValue('startDate', dateToPFormat(day, locale))
        setValue('endDate', dateToPFormat(startDate, locale))
        setValue('presetSelection', null)
        onChange(day, startDate)
        setDateNameSelected('startDate')
      } else {
        setValue('endDate', dateToPFormat(day, locale))
        setValue('presetSelection', null)
        onChange(startDate, day)
        setDateNameSelected('startDate')
      }
    }
  }

  return (
    <DayContainer
      inselection={isInSelection ? 1 : 0}
      first={startDate && isValid(startDate) && isEqual(day, startDate) ? 1 : 0}
      last={endDate && isValid(endDate) && isEqual(day, endDate) ? 1 : 0}
      isendofweek={isEndOfWeek ? 1 : 0}
      isstartofweek={isStartOfWeek ? 1 : 0}
    >
      <DayButton
        onClick={handleClick}
        inselection={isInSelection ? 1 : 0}
        selected={isSelected ? 1 : 0}
        outofmonth={isOutOfMonth ? 1 : 0}
        disabled={isDisabled}
      >
        {format(day, 'd')}
      </DayButton>
    </DayContainer>
  )
}
